import type { Project } from "@tudigo-monorepo/core-tudigo-api-models";

export const sortProjectsByMinGoalDESC = (
  projects?: Project[],
): Project[] | undefined => {
  return projects?.sort(
    (a, b) => b.fundraisingProgressMinGoal - a.fundraisingProgressMinGoal,
  );
};
